/**
 * 페이지별 기능 권한 체크 훅
 * PermissionProvider에서 제공하는 Context 사용
 */

import { createContext, useContext } from 'react';

export interface PermissionContextValue {
  permissions: Record<string, boolean>;
  loading: boolean;
  hasPermission: (key: string) => boolean;
}

export const PermissionContext = createContext<PermissionContextValue>({
  permissions: {},
  loading: true,
  hasPermission: () => true,
});

/**
 * 기능 권한을 확인하는 훅
 * @returns permissions 맵, loading 상태, hasPermission 함수
 */
export const usePermission = () => useContext(PermissionContext);
